(function () {
  if (window.atorhomeSizeDropdown) return;
  window.atorhomeSizeDropdown = true;

  const dataElement = document.getElementById('AtorhomeProductData');
  if (!dataElement) return;

  const data = JSON.parse(dataElement.textContent);
  const optionIndex = data.options.findIndex((name) => name.toLowerCase().includes(data.dropdownOption));
  if (optionIndex === -1) return;

  // Option names can carry stray whitespace from the admin (e.g. "Size "); legends are compared trimmed.
  const optionName = data.options[optionIndex].trim().toLowerCase();

  function optionControls(picker) {
    return [...picker.querySelectorAll('.product-form__input')].filter(
      (group) => group.querySelector('select, input[type="radio"]')
    );
  }

  function findFieldset(picker) {
    return optionControls(picker).find((group) => {
      const label = group.querySelector('legend, .form__label');
      return label && label.textContent.trim().toLowerCase() === optionName;
    });
  }

  function currentValue(group) {
    return group.querySelector('select')?.value ??
      group.querySelector('input[type="radio"]:checked')?.value ?? '';
  }

  function selectedValues(picker) {
    return optionControls(picker).map(currentValue);
  }

  // One entry per option value, taken from variants that match the other selected options.
  function optionEntries(picker) {
    const selected = selectedValues(picker);
    const entries = new Map();

    data.variants.forEach((variant) => {
      const matches = variant.options.every(
        (value, index) => index === optionIndex || !selected[index] || value === selected[index]
      );
      const value = variant.options[optionIndex];
      if (matches && !entries.has(value)) entries.set(value, variant);
    });

    return [...entries.entries()].map(([value, variant]) => ({
      value,
      price: variant.price,
      available: variant.available,
    }));
  }

  function closeAll(except) {
    document.querySelectorAll('.ator-size-dd.open').forEach((dropdown) => {
      if (dropdown === except) return;
      dropdown.classList.remove('open');
      dropdown.querySelector('.ator-size-dd__button').setAttribute('aria-expanded', 'false');
    });
  }

  function build(picker) {
    const fieldset = findFieldset(picker);
    if (!fieldset || fieldset.nextElementSibling?.classList.contains('ator-size-dd')) return;

    const entries = optionEntries(picker);
    const values = fieldset.querySelectorAll('select option, input[type="radio"]');
    if (values.length <= 2 || !entries.length) return;

    const checkedValue = currentValue(fieldset);
    const current = entries.find((entry) => entry.value === checkedValue) || entries[0];
    const menuId = `${fieldset.querySelector('select')?.id || fieldset.querySelector('input')?.id || 'AtorSize'}-menu`;

    const dropdown = document.createElement('div');
    dropdown.className = 'ator-size-dd';
    dropdown.innerHTML = `
      <span class="ator-size-dd__label"></span>
      <button type="button" class="ator-size-dd__button" aria-haspopup="listbox" aria-expanded="false" aria-controls="${menuId}">
        <span class="ator-size-dd__main"><span class="ator-size-dd__size"></span><span class="ator-size-dd__price"></span></span>
        <span class="ator-size-dd__chev" aria-hidden="true"></span>
      </button>
      <div class="ator-size-dd__menu" id="${menuId}" role="listbox"></div>`;

    dropdown.querySelector('.ator-size-dd__label').textContent = fieldset.querySelector('legend, .form__label')?.textContent.trim() || '';
    dropdown.querySelector('.ator-size-dd__size').textContent = current.value;
    dropdown.querySelector('.ator-size-dd__price').textContent = current.price;

    const menu = dropdown.querySelector('.ator-size-dd__menu');
    entries.forEach((entry) => {
      const item = document.createElement('button');
      item.type = 'button';
      item.className = 'ator-size-dd__option' + (entry === current ? ' is-selected' : '');
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', entry === current ? 'true' : 'false');
      item.disabled = !entry.available;
      item.innerHTML = '<span class="ator-size-dd__option-size"></span><span class="ator-size-dd__option-price"></span>';
      item.querySelector('.ator-size-dd__option-size').textContent = entry.value;
      item.querySelector('.ator-size-dd__option-price').textContent = entry.price;
      item.addEventListener('click', () => {
        closeAll(null);
        const select = fieldset.querySelector('select');
        if (select) {
          if (select.value !== entry.value) {
            select.value = entry.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          const input = [...fieldset.querySelectorAll('input[type="radio"]')].find((radio) => radio.value === entry.value);
          if (input && !input.checked) input.click();
        }
      });
      menu.appendChild(item);
    });

    const button = dropdown.querySelector('.ator-size-dd__button');
    button.addEventListener('click', () => {
      const open = !dropdown.classList.contains('open');
      closeAll(dropdown);
      dropdown.classList.toggle('open', open);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    fieldset.classList.add('ator-hidden-size-picker');
    fieldset.setAttribute('aria-hidden', 'true');
    fieldset.querySelectorAll('select, input').forEach((control) => { control.tabIndex = -1; });
    fieldset.after(dropdown);
  }

  function buildAll() {
    document.querySelectorAll('variant-selects').forEach(build);
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.ator-size-dd')) closeAll(null);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('.ator-size-dd.open');
    if (!open) return;
    closeAll(null);
    open.querySelector('.ator-size-dd__button').focus();
  });

  // Dawn replaces <variant-selects> after every option change; rebuild before the next paint.
  document.querySelectorAll('product-info').forEach((productInfo) => {
    new MutationObserver(buildAll).observe(productInfo, { childList: true, subtree: true });
  });

  buildAll();
})();
